import React from "react";
import { Avatar, List, Typography } from "antd";

const { Title } = Typography;

const SubscribersChart = ({ recentSubscribers }) => {
  if (!recentSubscribers.length) {
    return <div className="dashboard-empty-state">No subscribers yet.</div>;
  }

  return (
    <div className="dashboard-panel">
      <div className="dashboard-panel__header">
        <div className="dashboard-panel__header-copy">
          <span className="dashboard-panel__eyebrow">Audience</span>
          <Title level={5}>Recent Subscribers</Title>
          <span className="dashboard-panel__subtext">
            Keep an eye on the most recent audience additions and segment mix.
          </span>
        </div>
        <span className="dashboard-panel__metric">
          {recentSubscribers.length}
        </span>
      </div>
      <List
        itemLayout="horizontal"
        dataSource={recentSubscribers}
        className="dashboard-panel__list"
        renderItem={(subscriber) => (
          <List.Item>
            <List.Item.Meta
              avatar={
                <Avatar
                  src={`https://xsgames.co/randomusers/avatar.php?g=pixel&key=${subscriber.id}`}
                />
              }
              title={
                <a href="/admin/newsletter">{subscriber.email}</a>
              }
              description={
                <>
                  <div>{`Subscribed on ${new Date(
                    subscriber.createdAt
                  ).toLocaleDateString()}`}</div>
                  <span className="dashboard-panel__pill">
                    {subscriber.type}
                  </span>
                </>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
};

export default SubscribersChart;
